<template>
  <div>
    <h1 class="text-3xl">Advisors</h1>
    <div class="my-4">
      <span class="inline-flex rounded-md shadow-sm">
        <button
          @click="modalOpen = true"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition ease-in-out duration-150"
        >
          Add New Advisor
        </button>
      </span>
    </div>
    <add-advisor-modal :open.sync="modalOpen" />
    <table class="min-w-full mt-8">
      <thead>
        <tr>
          <th class="text-left">Name</th>
          <th class="text-left">Email</th>
          <th class="text-left">Status</th>
          <th class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="advisor in advisors" :key="advisor.id">
          <td class="text-left">
            {{ advisor.name }}
          </td>
          <td class="text-left">{{ advisor.email }}</td>
          <!-- TODO - ADD COLOR/MAKE BADGE -->
          <!-- TODO - DEAL WITH FAILED STATE -->
          <!-- TODO - TEST ME WITH NEW STATUS ENUMS -->
          <!-- TODO - CONFIRM WITH FAILED EMAIL -->
          <!-- TODO - INCLUDE ACCEPTED/MODIFIED TS AS TITLE ATTRIBUTE -->
          <td class="text-left">
            <span
              class="inline-flex items-center px-2 py-1 rounded text-sm leading-4 bg-gray-200 text-gray-800"
            >
              {{ advisor.status || "PENDING" }}
            </span>
          </td>
          <td>
            <!-- TODO - CENTRALIZE AND STYLE -->
            <!-- TODO - ADD DELETION CONFIRMATION MODAL -->
            <button
              type="button"
              @click="removeAdvisor(advisor)"
              class="inline-flex items-center px-1 py-1 border border-transparent rounded-full hover:bg-gray-300 focus:outline-none focus:border-blue-700 focus:shadow-outline-gray active:bg-gray-300 transition ease-in-out duration-150"
            >
              <i class="material-icons text-lg">delete</i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";

import AddAdvisorModal from "@/components/AddAdvisorModal";

export default {
  name: "AdvisorsView",
  components: {
    AddAdvisorModal,
  },
  data() {
    return {
      modalOpen: false,
    };
  },
  computed: mapState({
    advisors: (state) => state.advisors.advisors,
  }),
  methods: {
    removeAdvisor(advisor) {
      // TODO - TURN INTO MODAL
      // TODO - Add text about this sending them an email letting them know you've removed them as an advisor
      const areYouSure = confirm(
        `Are you sure you want to remove ${advisor.name} as an advisor?`
      );

      if (areYouSure) {
        this.$store.dispatch("advisors/removeAdvisor", advisor.id);
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
th {
  @apply text-gray-500 text-sm font-normal border-b border-gray-400 px-1;
}

td {
  @apply py-2 px-1;
}
</style>
